import {trim} from 'lodash';
import {FormProvider, useForm} from 'react-hook-form';

import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


export default function GitHubForm({onSave}) {
  const appContext = useAppContext();
  const formMethods = useForm({
    defaultValues: {
      gitHubUsername: '',
    },
  });
    
  const {handleSubmit, setError} = formMethods;
    
  const onSubmit = async (value) => {
    try {
      const gitHubStatsRez = await appContext.api.post('api/v1/github/search', {
        json: {
          gitHubUsername: trim(value?.gitHubUsername).toLowerCase(),
        },
        parseJson: true,
      });

      onSave(gitHubStatsRez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };
    
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} style={{display: 'flex'}}>
        <div className="input">
          <FormText label="GitHub Username" name="gitHubUsername" required={true} className="formText" />
        </div>
        <div className="input input--topPad">
          <FormSubmit key="save">Go</FormSubmit>
        </div>
      </form>
    </FormProvider>
  );
}
